export default __webpack_public_path__ + "static/media/icon_tag.551e595c.svg";